import { media } from '@/media';
import styled from 'styled-components';

export const ViralWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 20px;

  ${media.mobile`
    display: block;
    margin: 0px 6px;
    box-sizing: border-box;
  `}
`;

export const DimensionWrapper = styled.div`
  width: 100%;
  max-width: 592px;

  ${media.mobile`
    margin-bottom: 6px;
    max-width: 100%;
  `}
`;

export const TopicWrapper = styled.div`
  width: 100%;
  max-width: 592px;
  ${media.mobile`
    max-width: 100%;
  `}
`;
